import { defineNuxtPlugin } from '@nuxtjs/composition-api';
import { trackClickElementByName } from './track_click_element_by_name';
import { trackSocialSignUp } from './track_social_signup';

/**
 * @description Executes any custom hanlder for logging analytics.
 * Create a function (handler) that takes `context` as an argument, and pass it to `handlers[]`.
 * It will be invoked with `context`.
 */
export default defineNuxtPlugin(context => {
  const handlers = [trackClickElementByName, trackSocialSignUp];
  handlers.forEach(handler => handler(context));
});
